var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"navigate-small-button text-chplus-regular box-border border-2 font-bold select-none",class:{
    'text-nav-light': _vm.themeText === 'text-nav-light',
    'bg-white': _vm.theme === 'white',
    'border-white': _vm.theme === 'border-white' || _vm.theme === 'white',
    'text-white': !_vm.theme.startsWith('border-'),
    'bg-interaction-dark': _vm.theme === 'interaction-dark',
    'border-interaction-dark':
      _vm.theme === 'interaction-dark' || _vm.theme === 'border-interaction-dark',
    'text-interaction-dark':
      _vm.theme === 'border-interaction-dark' && _vm.themeText === null,
    'bg-color-regular': _vm.theme === 'regular',
    'border-color-regular': _vm.theme === 'border-regular' || _vm.theme === 'regular',
    'text-color-regular': _vm.theme === 'border-regular' || _vm.theme === 'white',
    'bg-contrast-dark': _vm.theme === 'contrast-dark',
    'border-contrast-dark':
      _vm.theme === 'border-contrast-dark' || _vm.theme === 'contrast-dark',
    'text-contrast-dark': _vm.theme === 'border-contrast-dark',
    'bg-contrast-light': _vm.theme === 'contrast-light',
    'border-contrast-light':
      _vm.theme === 'border-contrast-light' || _vm.theme === 'contrast-light',
    'text-contrast-light': _vm.theme === 'border-contrast-light'
  },on:{"click":_vm.onClick}},[(_vm.text == null)?_vm._t("default"):[_vm._v(_vm._s(_vm.text))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }